import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const SubscripationPlanVeiwController = () => {
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
  const getPlans = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.get(
        `${BASE_URL}plans/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_PLANS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_PLANS_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  const addPlans = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.post(
        `${BASE_URL}plans/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_PLANS_SUCCESS", payload: data });
      dispatch(getPlans());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Subscripation plan added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({ type: "ADD_PLANS_FAILURE", payload: { error } });
      toast.error(message);
      return Promise.reject(error); // ✅ return error
      
    }
  };
  const updatePlans = (id, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.put(
        `${BASE_URL}plans/${id}/`,
        reqData
      );
      dispatch({ type: "UPDATE_PLANS_SUCCESS", payload: response.data });
      dispatch(getPlans());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Plans data updated sucessfully");
      return Promise.resolve(response.data);
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({ type: "UPDATE_PLANS_FAILURE", payload: error });
      toast.error(message);
      return Promise.reject(error);
    }
  };
  const deletePlans = (planId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.delete(
        `${BASE_URL}plans/${planId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_PLANS_SUCCESS", payload: data });
      dispatch(getPlans());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Plans deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_PLANS_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };
  
  return {
    getPlans,
    addPlans,
    updatePlans,
    deletePlans
  };
};

export default SubscripationPlanVeiwController;
